export default "__VITE_ASSET__eh_rSJW6__"